import classNames from 'classnames';
import { Fragment } from 'react';
import StoryblokEditableComment from './storyblok/StoryblokEditableComment';

const ArticleHeader = ({ component, className }) => {
  return (
    <>
      <header className={classNames('article-header', className)}>
        <div className="article-header__section">{component.section}</div>
        <time
          dateTime={new Date(component.date)}
          className="article-header__detail t-tiny"
        >
          {component.date}
        </time>
        <div className="article-header__detail t-tiny">
          {component.readingTime}
        </div>
        <h1 className="article-header__title t-large">{component.title}</h1>
      </header>
    </>
  );
};

export default ArticleHeader;
